module.exports = __webpack_public_path__ + "img/child-1.2be217b.jpg?v=1763034624171";